import React from 'react';
import { Text } from '~/shared/components/Text/Text';
import { Title, DeliverySummaryWrapper } from './styled';
import { SummaryList } from '~/shared/components/Summary/components/SummaryList';
import { Product } from '~/lib/data-contract/salesforce';
import Typography from '~/shared/components/Typography/Typography';

type Props = {
    title: string;
    subtitle: string;
    showSummaryList: boolean;
    products?: Product[];
};

export const DeliverySummary = ({ title, subtitle, showSummaryList, products }: Props) => {
    return (
        <DeliverySummaryWrapper>
            <Title style={{ display: 'flex', flexDirection: 'row' }}>
                {title && (
                    <Typography
                        style={{ alignSelf: 'start' }}
                        variant="title-XS"
                        as="h1"
                        weight="bold"
                    >
                        {title}
                    </Typography>
                )}
            </Title>
            <Text variant="bodySmall">{subtitle}</Text>
            {showSummaryList && <SummaryList large={true} hasBorder products={products} />}
        </DeliverySummaryWrapper>
    );
};
